import React from 'react';
import { useSelector } from 'react-redux';
import InputField from '../../../../common/InputField';
import {
  accountNumberValidation,
  codesValidation,
  commissionValidation,
  nameOfAccountValidation,
  nameOfBankValidation,
} from '../../../../../helper/FeildValidations';

const Payout = (countryCodeSelection, isEdit) => {
  let country = countryCodeSelection.countryCodeSelection;
  let isEditSpace = countryCodeSelection.isEdit;
  const countryValue = useSelector(
    (state) => state.space?.spaceDetails?.data?.location?.country || []
  );
  return (
    <div className="basic-details-wrapper">
      <h3>Payout Details</h3>
      <InputField
        name={['payout', 'nameOfAccount']}
        label={'Name of account'}
        rules={nameOfAccountValidation}
        isDisabled={false}
      />
      <InputField
        name={['payout', 'bank']}
        label={'Bank'}
        rules={nameOfBankValidation}
        isDisabled={false}
      />
      <InputField
        name={['payout', 'accountNumber']}
        label={'Account Number'}
        rules={accountNumberValidation}
        isDisabled={false}
      />

      {(isEditSpace && countryValue === 'AUS') || (isEditSpace === false && country === 'AUS') ? (
        <>
          <InputField
            name={['payout', 'bsb']}
            label={'BSB'}
            rules={codesValidation}
            isDisabled={false}
          />
        </>
      ) : (
        <>
          <InputField
            name={['payout', 'swiftCode']}
            label={'Swift Code'}
            rules={codesValidation}
            isDisabled={false}
          />
          <InputField
            name={['payout', 'bankCode']}
            label={'Bank Code'}
            rules={codesValidation}
            isDisabled={false}
          />
          <InputField
            name={['payout', 'branchCode']}
            label={'Branch Code'}
            rules={codesValidation}
            isDisabled={false}
          />
          <InputField
            name={['payout', 'commission']}
            label={'Commission %'}
            rules={commissionValidation}
            isDisabled={false}
          />
        </>
      )}
    </div>
  );
};

export default Payout;
